import React, { useEffect, useState } from "react";
import Observations from '../../../../globalcomponents/patient360/medicalhistory/observations'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
const PatientObservation = (props) => {
  return (
    <>
      <Observations data={props.formValues.patientdata} app="Site" />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    state
  }
}

export default withRouter(connect(mapStateToProps, null)(PatientObservation));


